import { Card, Grid, Icon, Dialog, DialogTitle, DialogContent, DialogActions, Tooltip, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useEffect, useRef, useState } from 'react';
import { errorAlert, successAlert } from "utils/Functions";
import { get, postNoResponse } from 'utils/WebService';

const ImportMovimentation = () => {
    const fileInputRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [logs, setLogs] = useState([]);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [currentErrorMsg, setCurrentErrorMsg] = useState("");

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
            resolve(encoded);
        };
        reader.onerror = error => reject(error);
    });

    const fetchLogs = () => {
        get("/movimentacao-processo/import-log/list")
            .then(data => {
                setLogs(data);
            })
            .catch(err => console.error(err));
    };

    useEffect(() => {
        fetchLogs();
    }, []);

    const handleImportClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = async (event) => {
        const files = Array.from(event.target.files);
        if (!files || files.length === 0) return;

        setLoading(true);
        
        // Registra arquivos no log
        const newLogs = files.map(file => ({
            id: file.name + Date.now() + Math.random(),
            name: file.name,
            date: new Date().toLocaleString('pt-BR'),
            status: "Aguardando",
            errorMsg: null
        }));
        
        setLogs(prev => [...newLogs, ...prev]);

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const logId = newLogs[i].id;
            
            // Atualiza para Processando
            setLogs(prev => prev.map(log => log.id === logId ? { ...log, status: "Processando..." } : log));
            
            try {
                const base64 = await toBase64(file);
                const request = [{ base64File: base64, nameFile: file.name }];
                await postNoResponse("/movimentacao-processo/importar", request);
                
                // Sucesso
                setLogs(prev => prev.map(log => log.id === logId ? { ...log, status: "Concluído", date: new Date().toLocaleString('pt-BR') } : log));
            } catch (error) {
                console.error(error);
                let errorMessage = "Erro desconhecido";
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }
                
                // Erro
                setLogs(prev => prev.map(log => log.id === logId ? { ...log, status: "Erro", date: new Date().toLocaleString('pt-BR'), errorMsg: errorMessage } : log));
            }
        }

        setLoading(false);
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        successAlert("Processo de importação finalizado!", () => null);
        fetchLogs(); // Atualiza a lista do banco
    };

    const handleOpenError = (msg) => {
        setCurrentErrorMsg(msg);
        setErrorModalOpen(true);
    };

    return (
        <Grid container display="flex" justifyContent="center">
            <Grid item xs={12} md={12}>
                <Grid container spacing={3}>
                    <Grid item xs={12} display="flex" justifyContent="flex-start">
                        <input
                            type="file"
                            multiple
                            accept=".xlsx, .xls, .csv"
                            style={{ display: "none" }}
                            ref={fileInputRef}
                            onChange={handleFileChange}
                        />
                        <MDButton
                            variant="gradient"
                            color="info"
                            onClick={handleImportClick}
                            disabled={loading}
                            startIcon={<Icon>upload_file</Icon>}
                        >
                            {loading ? 'Processando...' : 'Selecionar e Importar'}
                        </MDButton>
                    </Grid>
                    
                    {logs.length > 0 && (
                        <Grid item xs={12}>
                            <Card>
                                <MDBox p={3}>
                                    <MDTypography variant="h6" fontWeight="medium" mb={2}>
                                        Logs de Importação
                                    </MDTypography>
                                    <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid #f0f2f5" }}>
                                        <Table>
                                            <TableHead sx={{ display: "table-header-group" }}>
                                                <TableRow>
                                                    <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Data/Hora</MDTypography></TableCell>
                                                    <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Arquivo</MDTypography></TableCell>
                                                    <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Usuário</MDTypography></TableCell>
                                                    <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Status</MDTypography></TableCell>
                                                    <TableCell align="center"><MDTypography variant="caption" fontWeight="bold" color="text">Observação</MDTypography></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {logs.map((log) => (
                                                    <TableRow key={log.id}>
                                                        <TableCell>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium">
                                                                {log.date}
                                                            </MDTypography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium">
                                                                {log.name}
                                                            </MDTypography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium">
                                                                {log.userName || "-"}
                                                            </MDTypography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <MDTypography variant="caption" color={log.status === 'Erro' ? 'error' : log.status === 'Concluído' ? 'success' : log.status === 'Processando...' ? 'info' : 'text'} fontWeight="bold">
                                                                {log.status}
                                                            </MDTypography>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {log.status === 'Erro' && log.errorMsg ? (
                                                                <Tooltip title="Ver Erro">
                                                                    <IconButton color="error" size="small" onClick={() => handleOpenError(log.errorMsg)}>
                                                                        <Icon fontSize="small">visibility</Icon>
                                                                    </IconButton>
                                                                </Tooltip>
                                                            ) : (
                                                                <MDTypography variant="caption" color="text">-</MDTypography>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </MDBox>
                            </Card>
                        </Grid>
                    )}
                </Grid>


            <Dialog open={errorModalOpen} onClose={() => setErrorModalOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Mensagem de Erro</DialogTitle>
                <DialogContent dividers>
                    <MDTypography variant="body2" color="text" sx={{ wordBreak: 'break-word' }}>
                        {currentErrorMsg}
                    </MDTypography>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setErrorModalOpen(false)} color="dark">
                        Fechar
                    </MDButton>
                </DialogActions>
            </Dialog>
            </Grid>
        </Grid>
    );
};

export default ImportMovimentation;
